import {DrupalNode} from "next-drupal";
import {IndustrySegmentHero} from "@/components/organisms/hero/industry-segment-hero";
import {useRef} from "react";
import {DrupalProductNode, IndustrySegmentsTaxonomyTerm} from "@/types/hygiena-types";

import dynamic from "next/dynamic";

const ContentIndustrySegments = dynamic(() => import("./content/content--industry-segments").then((mod) => mod.ContentIndustrySegments));

/**
 * The Industry/Segment page.
 *
 * @param taxonomy_term
 * @param additionalContent
 * @constructor
 */
export function TaxonomyIndustrySegments ({
  taxonomy_term,
  additionalContent,
}: {
  taxonomy_term: IndustrySegmentsTaxonomyTerm,
  additionalContent?: {
    relatedNews?: DrupalNode[],
    products?: DrupalProductNode[],
    childTerms?: IndustrySegmentsTaxonomyTerm[],
  }
}): JSX.Element {
  const childTerms = additionalContent?.childTerms?.filter(item => item?.path?.alias);
  const solutionsRef = useRef();
  const products: DrupalProductNode[] = additionalContent?.["products"] ?? [];

  return (
    <>
      <IndustrySegmentHero taxonomy_term={taxonomy_term} scrollRef={(childTerms?.length || products) ? solutionsRef : undefined}/>
      <ContentIndustrySegments taxonomy_term={taxonomy_term} additionalContent={additionalContent} solutionsRef={solutionsRef}/>
    </>
  )
}